// extracted by mini-css-extract-plugin
module.exports = {"imageblock":"CMSImageBlock_imageblock__3BkU7","editProps":"CMSImageBlock_editProps__15gOU"};